// Lightweight offline cache for GET responses.
// Stores JSON payloads in localStorage keyed by URL + query string.
// Used as a fallback when the network is down (renderer shows stale data + banner).

const PREFIX = "hasyapi:cache:";
const MAX_AGE_MS = 24 * 60 * 60 * 1000; // 24h

function _key(url) {
  return PREFIX + url;
}

export function cacheSet(url, data) {
  try {
    const payload = { t: Date.now(), data };
    localStorage.setItem(_key(url), JSON.stringify(payload));
  } catch {
    // Quota exceeded — best-effort prune oldest entries
    pruneOldest(20);
  }
}

export function cacheGet(url, maxAgeMs = MAX_AGE_MS) {
  try {
    const raw = localStorage.getItem(_key(url));
    if (!raw) return null;
    const { t, data } = JSON.parse(raw);
    if (Date.now() - t > maxAgeMs) return null;
    return { data, cachedAt: new Date(t) };
  } catch {
    return null;
  }
}

export function cacheClear(prefix = "") {
  const p = PREFIX + prefix;
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const k = localStorage.key(i);
    if (k && k.startsWith(p)) localStorage.removeItem(k);
  }
}

function pruneOldest(count) {
  const entries = [];
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i);
    if (k && k.startsWith(PREFIX)) {
      try {
        entries.push({ k, t: JSON.parse(localStorage.getItem(k)).t });
      } catch { /* ignore */ }
    }
  }
  entries.sort((a, b) => a.t - b.t);
  entries.slice(0, count).forEach((e) => localStorage.removeItem(e.k));
}
